<script setup lang="ts">
/**
 * 页脚。
 *
 * 它不再固定在屏幕底部：跟随内容，内容太短时由外层的 `mt-auto` 把它推到底。
 * "什么时候显示"由使用方决定——聊天页只在**有消息时**渲染它
 * （空会话已经有自己的免责声明，再压一个完整页脚会把第一屏吃掉）。
 *
 * 热线号码 12356 这里是字面量，与 `CRISIS_HOTLINE` 重复：
 * 页脚是纯文案，不参与任何逻辑分支，读起来比一次跨包 import 更直接。
 */

import { cn } from '../../lib/cn';

const props = defineProps<{ className?: string }>();
</script>

<template>
  <footer :class="cn('border-t border-slate-200 bg-white px-4 py-6', props.className)">
    <div class="mx-auto max-w-5xl space-y-2 text-xs leading-relaxed text-slate-500">
      <p>
        本平台提供家庭教育与心理健康的<strong class="font-medium text-slate-700">知识性参考</strong>，不构成医疗诊断或治疗建议，不能替代执业医师、心理治疗师的面诊。
      </p>
      <p>
        如果你或家人正处于危机中，请立即拨打全国心理援助热线
        <strong class="font-medium text-safety-600">12356</strong>（24 小时），或前往最近的医院急诊。
      </p>
      <p class="flex flex-wrap gap-x-4 gap-y-1">
        <RouterLink to="/chat" class="hover:text-brand-700">开始咨询</RouterLink>
        <RouterLink to="/quota" class="hover:text-brand-700">额度说明</RouterLink>
        <span>内容由 AI 生成，请结合实际情况判断</span>
      </p>
    </div>
  </footer>
</template>
